/**
 * Parameter Tabs Component
 * Tab navigation for On-Page, Off-Page, and Technical parameters
 */

import React from 'react';

type TabType = 'onpage' | 'offpage' | 'technical';

interface ParameterTabsProps {
    activeTab: TabType;
    onTabChange: (tab: TabType) => void;
}

const ParameterTabs: React.FC<ParameterTabsProps> = ({ activeTab, onTabChange }) => {
    const tabs: { id: TabType; label: string; icon: string }[] = [
        { id: 'onpage', label: 'On-Page', icon: '📄' },
        { id: 'offpage', label: 'Off-Page', icon: '🔗' },
        { id: 'technical', label: 'Technical', icon: '⚙️' },
    ];

    return (
        <div className="parameter-tabs">
            {tabs.map((tab) => (
                <button
                    key={tab.id}
                    className={`tab-btn ${activeTab === tab.id ? 'active' : ''}`}
                    onClick={() => onTabChange(tab.id)}
                >
                    <span className="tab-icon">{tab.icon}</span>
                    <span className="tab-label">{tab.label}</span>
                </button>
            ))}
        </div>
    );
};

export default ParameterTabs;
